import Constants from 'Constants'

const { INTERCOM_APP_ID } = Constants

export interface IntercomCompanyParams {
  id: string
  // eslint-disable-next-line camelcase
  company_id: string
  name: string
  website?: string | null
  // eslint-disable-next-line camelcase
  customer_portal_website?: string
}

export interface IntercomBootParams {
  // eslint-disable-next-line camelcase
  app_id?: string
  // eslint-disable-next-line camelcase
  vertical_padding?: number
  // eslint-disable-next-line camelcase
  user_id?: string
  name?: string
  email?: string | null
  phone?: string | null
  // eslint-disable-next-line camelcase
  created_at?: number | null
  company?: IntercomCompanyParams
  /** JWT token for Intercom identity verification (HS256-signed server-side). */
  // eslint-disable-next-line camelcase
  intercom_user_jwt?: string
  /** Hides the launcher circle without shutting the Messenger down. */
  // eslint-disable-next-line camelcase
  hide_default_launcher?: boolean
}

declare global {
  interface Window {
    Intercom?: (command: 'boot' | 'update' | 'shutdown', params?: IntercomBootParams) => void
  }
}

const VERTICAL_PADDING = 65
// Intercom's Messenger launcher is a fixed 48px circle, and it only docks to a bottom
// corner — the page has to make the room rather than move it.
const LAUNCHER_SIZE = 48
const LAUNCHER_GAP = 16

/**
 * Bottom clearance a scrollable panel needs so its last item can be scrolled out from
 * under the launcher instead of sitting behind it.
 */
export const INTERCOM_LAUNCHER_CLEARANCE = VERTICAL_PADDING + LAUNCHER_SIZE + LAUNCHER_GAP

const BASE_PARAMS: IntercomBootParams = { app_id: INTERCOM_APP_ID as string, vertical_padding: VERTICAL_PADDING }

export const initializeIntercom = (params: IntercomBootParams = {}): void => {
  window.Intercom?.('boot', { ...BASE_PARAMS, ...params })
}

export const updateIntercom = (params: IntercomBootParams = {}): void => {
  window.Intercom?.('update', { ...BASE_PARAMS, ...params })
}

/**
 * Hides or restores the launcher circle. It docks to a bottom corner at a z-index
 * above all app chrome, so a full-height overlay has to hide it rather than out-stack it.
 */
export const setIntercomLauncherHidden = (hidden: boolean): void => {
  updateIntercom({ hide_default_launcher: hidden })
}

export const shutdownIntercom = (): void => {
  window.Intercom?.('shutdown')
  initializeIntercom()
}
